import _ from "lodash";
import { Grid } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftSelect from "components/SoftSelect";
import SoftTypography from "components/SoftTypography";
import { useEffect, useState } from "react";
import ApiService from "services/ApiService";
import ToastUtils from "utils/ToastUtils";

function RoleSelect({ xs = 12, md = 4, handler, initialValue = null }) {
  const [roles, setRoles] = useState([]);
  const [value, setValue] = useState(null);

  const handleChange = (e) => {
    setValue(e);
    handler(e.id);
  };

  const fetchRoles = async () => {
    const response = await ApiService.getData(`/api/v1/roles`);

    if (!response) {
      ToastUtils.error("Αδυναμία εύρεσης ρόλων!");
      return;
    }

    response.data.data.map((el) => {
      el.value = el.id;
      el.label = el.name.charAt(0).toUpperCase() + el.name.slice(1);
    });
    setRoles(_.sortBy(response.data.data, "accessLevel", "desc"));
  };

  const selectRoleById = async () => {
    let selectedRole = roles.find((el) => el.id === initialValue);
    if (!selectedRole) return;
    setValue(selectedRole);
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  useEffect(() => {
    selectRoleById();
  }, [initialValue]);

  return (
    <Grid item xs={xs} md={md}>
      <SoftBox display="flex" flexDirection="column" justifyContent="flex-end" height="100%">
        <SoftBox mb={1} ml={0.5} mt={3} lineHeight={0} display="inline-block">
          <SoftTypography
            component="label"
            variant="caption"
            fontWeight="bold"
            textTransform="capitalize"
          >
            Επιλογή Ρόλου
          </SoftTypography>
        </SoftBox>
        <SoftSelect
          placeholder="Επιλογή Ρόλου"
          options={roles}
          size="large"
          onChange={handleChange}
          value={value}
        />
      </SoftBox>
    </Grid>
  );
}

export default RoleSelect;
